import { ReactNode, useContext, useEffect } from "react";
import { OwnerModuleContext } from "../context";

/** Applies the ID of the current module to the body as a CSS class. */
export const BodyModuleClass = (): ReactNode => {
  const ownerContext = useContext(OwnerModuleContext);

  useEffect(() => {
    if (ownerContext) {
      const id = ownerContext.id;
      document.body.classList.add(id);

      return () => {
        document.body.classList.remove(id);
      };
    }
  }, [ownerContext?.id]);

  return null;
};
